import { useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import { useState } from 'react'

import { unwrapApiData } from '@/api/unwrapApiResult'
import { invalidateAdminCaches } from '@/utils/cacheInvalidation'

interface Props {
  resourceLabel: string
  terminateFn: () => Promise<{
    response: Response
    data?: unknown
    error?: unknown
  }>
  onSuccess?: () => void
}

export function useDetailTermination({
  resourceLabel,
  terminateFn,
  onSuccess,
}: Props) {
  const queryClient = useQueryClient()
  const [open, setOpen] = useState(false)

  const handleTerminate = async () => {
    const result = await terminateFn()
    unwrapApiData(result, `Failed to terminate ${resourceLabel}`)
    setOpen(false)
    void message.success(`${resourceLabel} terminated`)
    invalidateAdminCaches(queryClient)
    onSuccess?.()
  }

  return {
    terminateOpen: open,
    openTerminate: () => setOpen(true),
    closeTerminate: () => setOpen(false),
    handleTerminate,
  }
}
